export default __webpack_public_path__ + "static/media/ic_pograma_pacientes.9e3279f5.svg";